import React from "react"
import { Box, Image as ImageG } from "grommet"
import styled from "styled-components"
import FemaleIcon from "../../images/rtg/female-icon-white.png"
import MaleIcon from "../../images/rtg/male-icon-white.png"
import UnisexIcon from "../../images/rtg/unisex-icon-white.png"

const Image = styled(ImageG)`
  /* margin-bottom: 0; */
  width: 12px;
  height: 12px;
`

const IconModal = ({ size, name }) => {
  const icons = {
    FemaleIcon,
    MaleIcon,
    UnisexIcon,
  }
  let bgColor = "#B621F0"
  switch (name) {
    case "UnisexIcon":
      bgColor = "#B621F0"
      break
    case "MaleIcon":
      bgColor = "#2984F0"
      break
    case "FemaleIcon":
      bgColor = "#FC1845"
      break
  }
  return (
    <Box
      round
      width={size}
      height={size}
      background={bgColor}
      //   padding="3px"
      align="center"
      justify="center"
      fit
    >
      <Image src={icons[name]} alt={name} />
    </Box>
  )
}

export default IconModal
